import { booleanAttribute } from "#ce/utils/props";

export const DEFAULT_COUNT = 6;

// The largest passcode length the element renders.
export const MAX_COUNT = 12;

// `value` is absent on purpose: the element owns a live `value` property, which a declared prop
// would shadow. The `value` attribute seeds the digits and a form reset restores it.
export const props = Object.freeze({
  /**
   * Number of digit boxes, from 1 to 12. A value that is not a whole number in that range falls
   * back to the default.
   *
   * @type {Number|String}
   * @default 6
   * @storybook-control number
   */
  count: {
    type: [Number, String],
    default: DEFAULT_COUNT,
  },
  /**
   * Removes the ability to focus or edit the boxes.
   *
   * @type {Boolean|String}
   * @default false
   */
  disabled: booleanAttribute(),
  /**
   * Space-separated ids of the elements that label the group, resolved in the tree the element
   * itself sits in. Set it as `aria-labelledby` on the element. Without it, the `<label for>`
   * pointing at the element names the group.
   *
   * @type {String}
   * @default undefined
   */
  ariaLabelledby: {
    type: String,
    default: undefined,
  },
  /**
   * Sets a `data-testid` on every digit box.
   *
   * @type {String}
   * @default undefined
   */
  digitTestId: {
    type: String,
    default: undefined,
  },
});
